/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { placeControllerCreate } from '../fn/place/place-controller-create';
import { PlaceControllerCreate$Params } from '../fn/place/place-controller-create';
import { placeControllerDelete } from '../fn/place/place-controller-delete';
import { PlaceControllerDelete$Params } from '../fn/place/place-controller-delete';
import { placeControllerFindAll } from '../fn/place/place-controller-find-all';
import { PlaceControllerFindAll$Params } from '../fn/place/place-controller-find-all';
import { placeControllerFindById } from '../fn/place/place-controller-find-by-id';
import { PlaceControllerFindById$Params } from '../fn/place/place-controller-find-by-id';
import { placeControllerHasPick } from '../fn/place/place-controller-has-pick';
import { PlaceControllerHasPick$Params } from '../fn/place/place-controller-has-pick';
import { placeControllerSearch } from '../fn/place/place-controller-search';
import { PlaceControllerSearch$Params } from '../fn/place/place-controller-search';
import { placeControllerUpdate } from '../fn/place/place-controller-update';
import { PlaceControllerUpdate$Params } from '../fn/place/place-controller-update';
import { PlaceDto } from '../models/place-dto';
import { PlaceSearchResponseDto } from '../models/place-search-response-dto';

@Injectable({ providedIn: 'root' })
export class PlaceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `placeControllerSearch()` */
  static readonly PlaceControllerSearchPath = '/api/places/search';

  /**
   * 장소 오프셋 기반 조회.
   *
   * 장소를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearch$Response(params: PlaceControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceSearchResponseDto>> {
    return placeControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 오프셋 기반 조회.
   *
   * 장소를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearch(params: PlaceControllerSearch$Params, context?: HttpContext): Observable<PlaceSearchResponseDto> {
    return this.placeControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaceSearchResponseDto>): PlaceSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `placeControllerFindAll()` */
  static readonly PlaceControllerFindAllPath = '/api/places';

  /**
   * 모든 장소 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindAll$Response(params?: PlaceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlaceDto>>> {
    return placeControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 장소 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindAll(params?: PlaceControllerFindAll$Params, context?: HttpContext): Observable<Array<PlaceDto>> {
    return this.placeControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlaceDto>>): Array<PlaceDto> => r.body)
    );
  }

  /** Path part for operation `placeControllerCreate()` */
  static readonly PlaceControllerCreatePath = '/api/places';

  /**
   * 새 장소 등록.
   *
   * 새로운 장소를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerCreate$Response(params: PlaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
    return placeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 장소 등록.
   *
   * 새로운 장소를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerCreate(params: PlaceControllerCreate$Params, context?: HttpContext): Observable<PlaceDto> {
    return this.placeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaceDto>): PlaceDto => r.body)
    );
  }

  /** Path part for operation `placeControllerFindById()` */
  static readonly PlaceControllerFindByIdPath = '/api/places/{id}';

  /**
   * 장소 조회.
   *
   * 입력한 ID와 일치하는 장소를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindById$Response(params: PlaceControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
    return placeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 조회.
   *
   * 입력한 ID와 일치하는 장소를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindById(params: PlaceControllerFindById$Params, context?: HttpContext): Observable<PlaceDto> {
    return this.placeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaceDto>): PlaceDto => r.body)
    );
  }

  /** Path part for operation `placeControllerDelete()` */
  static readonly PlaceControllerDeletePath = '/api/places/{id}';

  /**
   * 장소 삭제.
   *
   * 장소를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerDelete$Response(params: PlaceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return placeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 삭제.
   *
   * 장소를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerDelete(params: PlaceControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.placeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `placeControllerUpdate()` */
  static readonly PlaceControllerUpdatePath = '/api/places/{id}';

  /**
   * 장소 수정.
   *
   * 장소 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerUpdate$Response(params: PlaceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
    return placeControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 수정.
   *
   * 장소 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerUpdate(params: PlaceControllerUpdate$Params, context?: HttpContext): Observable<PlaceDto> {
    return this.placeControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaceDto>): PlaceDto => r.body)
    );
  }

  /** Path part for operation `placeControllerHasPick()` */
  static readonly PlaceControllerHasPickPath = '/api/places/{id}/has-pick';

  /**
   * 장소에 픽 존재 여부 확인.
   *
   * 특정 장소가 픽에 등록되어 있는지를 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerHasPick()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerHasPick$Response(params: PlaceControllerHasPick$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return placeControllerHasPick(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소에 픽 존재 여부 확인.
   *
   * 특정 장소가 픽에 등록되어 있는지를 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerHasPick$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerHasPick(params: PlaceControllerHasPick$Params, context?: HttpContext): Observable<boolean> {
    return this.placeControllerHasPick$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
